export default "__VITE_ASSET__r0fS7sLJ__"